module.exports = __webpack_public_path__ + "static/img/part_1_blue.c54547e1.png";